import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ControleSessaoService } from '../services/controle-sessao.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private controleSessao: ControleSessaoService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Apenas envia Authorization para a API do backend (evita vazar credenciais)
    if (!this.isApiRequest(req.url)) {
      return next.handle(req);
    }

    let authReq = req;

    const token = this.controleSessao.getAccessToken();
    if (token && !authReq.headers.has('Authorization')) {
      authReq = authReq.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(authReq);
  }

  private isApiRequest(url: string): boolean {
    if (!url) return false;
    if (this.isRelativeUrl(url)) return true;

    const base = (environment.baseURL || '').trim().replace(/\/+$/, '');
    if (!base) return false;
    return url.startsWith(base);
  }

  private isRelativeUrl(url: string): boolean {
    return !/^https?:\/\//i.test(url);
  }
}
